import {TNullable} from './generics';

export type TLinkParameters = {[index: string]: string};

export enum ELinkMethod {
    GET = 'GET',
    POST = 'POST'
}

export enum ELinkType {
    'INTERNAL' = 'INTERNAL',
    'INNER_TABLE_REPORT_DD' = 'INNER_TABLE_REPORT_DD',
    'EXTERNAL' = 'EXTERNAL',
    'FILE' = 'FILE',
    'FILE_WITH_TOKEN' = 'FILE_WITH_TOKEN',
    'EXTERNAL_WITH_TOKEN' = 'EXTERNAL_WITH_TOKEN',
    'MODAL' = 'MODAL',
    'MODAL_WITH_TOKEN' = 'MODAL_WITH_TOKEN',
    'DATA_WITH_TOKEN' = 'DATA_WITH_TOKEN',
    'PDF_WITH_ERROR_FALLBACK' = 'PDF_WITH_ERROR_FALLBACK',
    'SUBMENU' = 'SUBMENU',
}

export enum ELinkModalViewType {
    'TABLE' = 'TABLE'
}

export type TLinkDto<T = {
    url: string;
    urlType: ELinkType;
    modalViewProperties: {
        id: number;
        name: string;
        type: ELinkModalViewType;
        tableColumns: Record<string, string>;
    };
    method : ELinkMethod;
    queryParameters : TLinkParameters;
    bodyParameters : TLinkParameters;
    filterParameters : TLinkParameters;
    token?: string;
    tokenProperties: TLinkTokenPropertiesDto;
    ignoreRequiredParameters: boolean;
    linkProperties: {
        title?: string | null;
        type?: 'button' | 'link' | 'submenu';
        icon?: string;
    };
    headerParameters: {
        [key: string] : string;
    };
    // todo: Убрать поле position и отрефакторить связанные компоненты
    position: {
        column?: string;
        placement?: string;
        ordinal?: number;
        title?: string;
    };
    suppressMessages?: boolean;
    shouldRefetchTableData?: boolean;
    bodyType?: string;
    extraData?: TCustomLinkExtraData;
    children?: TLinkDto[];
  }> = Partial<TNullable<T, keyof T>>;

export type TLinkTokenPropertiesDto<T = {
    url: string;
    method: ELinkMethod;
    tokenKey: string;
    queryParameters: TLinkParameters;
    bodyParameters: TLinkParameters;
}> = Partial<TNullable<T, keyof T>>;

export type TLinkTableReportPositionInfo = {
    fieldName?: string;
    position?: TLinkDto['position'];
    useTableValueAsTitle?: boolean;
}

export type TLinkMeta = Pick<TLinkDto, 'ignoreRequiredParameters'>; // вспомогательные данные для переходов

// свойста кнопки при рендере извне, когда нужно задать их в обход данных конфига LinkDto[linkProperties]
export interface IExternalLinkProperties {
    title?: string;
    icon?: string;
}

export type TCustomLinkExtraData = {
    tableReportDrilldownParams?: {
        name: string;
        docId: string | null;
        templateCode: string;
    };
};
